export default __webpack_public_path__ + "static/media/googlePlayButton.bd22d187.svg";